import { Modal, Typography } from 'antd';
import * as React from 'react';

import { MODAL_SIZES } from 'config/modaSettings';
import { DEFAULT_TEXT_CONFIG } from 'config/texts';
import { Z_INDEX } from 'config/zIndicies';

import { TEXT_CONFIG } from './texts';

export type LogoutModalProps = {
  isOpen: boolean;
  onCancel: VoidFunction;
  onOk: () => Promise<void>;
  isLoading: boolean;
};

const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onCancel,
  onOk,
  isLoading,
}) => {
  return (
    <Modal
      width={MODAL_SIZES.s}
      onCancel={onCancel}
      open={isOpen}
      cancelText={DEFAULT_TEXT_CONFIG.CANCEL_BUTTON}
      okText={DEFAULT_TEXT_CONFIG.EXIT_BUTTON}
      onOk={onOk}
      centered
      confirmLoading={isLoading}
      zIndex={Z_INDEX.LOGOUT_MODAL}
    >
      <Typography.Text>{TEXT_CONFIG.LOGOUT_MODAL_TEXT}</Typography.Text>
    </Modal>
  );
};

export default React.memo(LogoutModal);
